'use client'

import styles from './VideoInline.module.scss'
import { useEffect, useMemo, useState } from 'react'
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer'
import { createPlayerProps } from '@/elements/widgets/Video/utils'
import type { VideoPlayerProps } from '@/types/video'
import { PlayerInterface } from '@foundation-player/loader'
import StructuredData from '@/elements/widgets/Video/StructuredData'
import { PlayerEvent } from '@foundation-player/core'
import AppContext from '@/types/context'
import { useIsPurMode } from '@/hooks/useIsPurMode'

const VideoInline = ({ item, context }: { item: any; context: AppContext }) => {
  const [player, setPlayer] = useState<PlayerInterface | undefined>(undefined)
  const [playListIndex, setPlayListIndex] = useState<number>(0)

  const videoContext = item.items[0]

  const isPurMode = useIsPurMode()

  const [playerProps, setPlayerProps] = useState<VideoPlayerProps | undefined>(
    videoContext
      ? createPlayerProps({
          context: videoContext,
          autoplay: false,
          heartbeatStarttype: 0,
          isPurMode,
        })
      : undefined,
  )

  useEffect(() => {
    const handleSessionEnd = () => {
      if (item.items[0]) {
        setPlayerProps(
          createPlayerProps({
            context: item.items[0],
            autoplay: false,
            heartbeatStarttype: 1,
            isPurMode,
          }),
        )
        setPlayListIndex(playListIndex + 1)
      }
    }

    if (player) {
      player.addEventListener(PlayerEvent.SessionEnd, handleSessionEnd)
    }

    return () => {
      if (player) {
        player.removeEventListener(PlayerEvent.SessionEnd, handleSessionEnd)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player])

  if (!(videoContext && playerProps)) return null

  const videoPlayer = useMemo(
    () => (
      <VideoPlayer
        props={createPlayerProps({
          context: videoContext,
          autoplay: false,
          heartbeatStarttype: 0,
          isPurMode,
        })}
        providePlayer={setPlayer}
      />
    ),
    [videoContext],
  )
  return (
    <>
      <StructuredData item={videoContext} />
      <div className={styles.wrapper}>
        <h2 className={styles.headline}>{videoContext?.model?.headline}</h2>
        <div>{videoPlayer}</div>
      </div>
    </>
  )
}

export default VideoInline
